import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const Ranking = props => (
  <div className="container-detail-ranking">
    <h2>{props.language.detail_waiting_times.fufillment.driverRanking}</h2>
    <ul className="container-detail-table-ul">
      <li className="container-detail-table-li">
        <strong>{props.language.detail_waiting_times.fufillment.fulfillment}:</strong>
        {props.language.detail_waiting_times.fufillment.allIndicators}
        <ul>
          <li>Test</li>
          <li>Test</li>
        </ul>
      </li>
    </ul>
    <div className="box-detail-ranking">
      <table>
        <tbody>
          <tr>
            <th>20</th>
            <td>
              <h3>Bernardo de jesus Bustamante valencia</h3>
              <h4>ID:1234XXXX</h4>
            </td>
            <td className="td-circular">
              <CircularProgress
                className={'circular-red'}
                variant="static"
                value={40}
                thickness={3}
                size={50}
              />
              <h5 className="red">40%</h5>
              <span className="red">
                <i className="fas fa-arrow-down" />
              </span>
            </td>
          </tr>
          <tr>
            <th>20</th>
            <td>
              <h3>Bernardo de jesus Bustamante valencia</h3>
              <h4>ID:1234XXXX</h4>
            </td>
            <td className="td-circular">
              <CircularProgress
                className={'circular-red'}
                variant="static"
                value={45}
                thickness={3}
                size={50}
              />
              <h5 className="red">45%</h5>
              <span className="red">
                <i className="fas fa-arrow-down" />
              </span>
            </td>
          </tr>
          <tr>
            <th>20</th>
            <td>
              <h3>Bernardo de jesus Bustamante valencia</h3>
              <h4>ID:1234XXXX</h4>
            </td>
            <td className="td-circular">
              <CircularProgress
                className={'circular-red'}
                variant="static"
                value={40}
                thickness={3}
                size={50}
              />
              <h5 className="red">40%</h5>
              <span className="red">
                <i className="fas fa-arrow-down" />
              </span>
            </td>
          </tr>
          <tr>
            <th>20</th>
            <td>
              <h3>Bernardo de jesus Bustamante valencia</h3>
              <h4>ID:1234XXXX</h4>
            </td>
            <td className="td-circular">
              <CircularProgress
                className={'circular-red'}
                variant="static"
                value={70}
                thickness={3}
                size={50}
              />
              <h5 className="red">70%</h5>
              <span className="red">
                <i className="fas fa-arrow-down" />
              </span>
            </td>
          </tr>
          <tr>
            <th>20</th>
            <td>
              <h3>Bernardo de jesus Bustamante valencia</h3>
              <h4>ID:1234XXXX</h4>
            </td>
            <td className="td-circular">
              <CircularProgress
                className={'circular-red'}
                variant="static"
                value={90}
                thickness={3}
                size={50}
              />
              <h5 className="red">90%</h5>
              <span className="red">
                <i className="fas fa-arrow-down" />
              </span>
            </td>
          </tr>
          <tr>
            <th>20</th>
            <td>
              <h3>Bernardo de jesus Bustamante valencia</h3>
              <h4>ID:1234XXXX</h4>
            </td>
            <td className="td-circular">
              <CircularProgress
                className={'circular-red'}
                variant="static"
                value={90}
                thickness={3}
                size={50}
              />
              <h5 className="red">90%</h5>
              <span className="red">
                <i className="fas fa-arrow-down" />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default Ranking;



// WEBPACK FOOTER //
// ./source/client/components/detail_fulfillment/ranking.jsx